import { Checkbox, Group, PasswordInput, Radio } from '@mantine/core';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import notify from '../../../utils/Notification';
import '../body/AppBody.css';
import './SignUpDetailsMainContent.css';
import { DateInput } from '@mantine/dates';

const SignUpDetailsMainContent = () => {
    const [verificationType, setVerificationType] = useState("BUSINESS");
    console.log(verificationType, "mk")
    const [formValues, setFormValues] = useState({
        companyName: '',
        name: '',
        mobileNo: '',
        email: '',
        collegeName: '',
        courseName: '',
        memberShipEndDate: null,
        password: '',
    });
    useEffect(() => {
        setFormValues((prev) => ({
            ...prev,
            customerType: verificationType,
        }));
    }, [verificationType]);
    useEffect(() => {
        setFormValues((prev) => ({
            ...prev,
            companyName: '',
            name: '',
            mobileNo: '',
            email: '',
            collegeName: '',
            courseName: '',
            memberShipEndDate: null,
            password: '',
        }));

    }, [verificationType]);


    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const handleInputChange = (e) => {
        setFormValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };
    const handleDateChange = (value) => {
        setFormValues((prev) => ({
            ...prev,
            memberShipEndDate: value
        }));
    };

    const [checked, setChecked] = useState(true);


    const submitHandler = async (e) => {
        e.preventDefault();
        if (!checked)
            return
        try {
            const res = await B2B_API.post(`customer/signup`, { json: formValues }).json();
            notify({
                error: false,
                success: true,
                title: res?.message || 'Sign-Up Successful'
            })
            navigate('/login')
        } catch (error) {
            notify({
                error: true,
                success: false,
                title: error?.message || 'Something went wrong'
            })
        }
    };

    return (
        <div className="view-sign-up router-view-container">
            <h1 className="page-title" style={{ display: "flex", paddingBottom: "0px" }}>Buyer Sign up</h1>
            <div style={{ display: "flex", paddingBottom: "10px" }}><Radio.Group value={verificationType}>
                <Group gap="xs" mt="xs">
                    <Radio
                        value="BUSINESS"
                        label="BUSINESS"
                        size="sm"
                        styles={{ label: { fontSize: 14 } }}
                        onClick={() => setVerificationType("BUSINESS")}
                    />
                    <Radio
                        value="STUDENT"
                        label="STUDENT"
                        size="sm"
                        styles={{ label: { fontSize: 14 } }}
                        onClick={() => setVerificationType("STUDENT")}
                    />
                </Group>
            </Radio.Group></div>
            <div className="layout">
                <form className="sign-up-form-basic sign-up-form" onSubmit={submitHandler} data-gtm-form-interact-id="1">

                    <div className="form-control required payload-brand-name">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Company Name</span> <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="companyName"
                                className="required-but-empty"
                                value={formValues.companyName}
                                onChange={handleInputChange}
                                type="text"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-control required payload-name">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Name</span><span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="name"
                                className="required-but-empty"
                                value={formValues.name}
                                onChange={handleInputChange}
                                type="text"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-control required payload-mobile-number">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Mobile Number</span><span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                className="required-but-empty"
                                value={formValues.mobileNo}
                                onChange={handleInputChange}
                                pattern="[0-9]{10}"
                                maxLength="10"
                                minLength="10"
                                name="mobileNo"
                                onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} // Removes non-digit characters
                                required
                            />

                        </div>
                    </div>

                    <div className="form-control required payload-email">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Email</span><span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="email"
                                inputMode="email"
                                value={formValues.email}
                                onChange={handleInputChange}
                                type="email"
                                required
                            />
                        </div>
                    </div>
                    {verificationType === "STUDENT" && <div className="form-control required payload-name">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">College Name</span><span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="collegeName"
                                className="required-but-empty"
                                value={formValues.collegeName}
                                onChange={handleInputChange}
                                type="text"
                                required
                            />
                        </div>
                    </div>}
                    {verificationType === "STUDENT" && <div className="form-control required payload-name">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Course Name</span><span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <input
                                name="courseName"
                                className="required-but-empty"
                                value={formValues.courseName}
                                onChange={handleInputChange}
                                type="text"
                                required
                            />
                        </div>
                    </div>}
                    {verificationType === "STUDENT" && <div className="form-control required payload-name">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">MemberShip End Date</span><span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-and-error">
                            <DateInput
                                value={formValues.memberShipEndDate}
                                onChange={handleDateChange}
                                valueFormat="DD/MM/YYYY"
                                placeholder="DD/MM/YYYY"
                                minDate={new Date()}
                                required
                            />
                        </div>
                    </div>}

                    {/* <div className="form-control required payload-password">
                        <label className="flex-row items-center">
                            <span className="flex-wrap">Create Password</span>
                        </label>
                        <div className="input-and-error">
                            <PasswordInput
                                name="password"
                                placeholder='Enter password'
                                value={formValues.password}
                                onChange={handleInputChange}
                                required
                                 minLength={6} 
                                radius='sm'
                                size='md'
                            />
                        </div>  
                    </div> */}

                    <div className="flex-row m-t-32">
                        <Checkbox
                            color="#8BC53F"
                            checked={checked}
                            style={{ marginTop: '10px' }}
                            onChange={(event) => setChecked(event.currentTarget.checked)}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
                            <div>   Get emails from FabInsta about product updates, industry news, and events</div>
                            <div>I have read the terms and conditions</div>
                        </div>
                    </div>
                    <div className="line"></div>


                    <button
                        type="submit"

                        className="btn btn-primary btn-submit btn-block"
                        disabled={!checked}
                        style={{ cursor: checked ? 'pointer' : 'not-allowed', opacity: checked ? 1 : 0.8 }}
                    >
                        <div>Sign Up</div>
                    </button>

                    <div className="sign-in-button-wrapper">
                        Have an account?
                        <a className="sign-in-button" href="/login">Sign in</a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SignUpDetailsMainContent;
